









import { Vue } from 'division-marker';
import { Component, Prop, Watch, SaitenState, ConstsState, DmShareds, Modal, CombineQrReader} from 'saiten-base';


@Component({components: {CombineQrReader, Modal}, mixins:[]})
export default class QrDialog extends Vue {
  @Prop() expected_qr!: string
  @Prop() page!: string
  error: string | null = null
  get modal(){return this.$refs.myModalRef as Modal}
  mounted() {
    this.modal.show()
  }
  
  
  onDecode(content: string) {
    console.log(`decoded! ${content}`)
    if(content == this.expected_qr){
      console.log(`ok!!`)
      this.$emit('qr_success')
    }else{
      console.log(`ng!!`)
      // this.$emit('qr_error', `二次元バーコードエラー[${content}]。講座・ページを確認してください。`)
      this.error = `二次元バーコードエラー[${content}] 講座・ページを確認してください。`;
    }
  }
  hidden(){
    this.$emit('hide')
    console.log('hidden')
  }
}
